import { render, staticRenderFns } from "./levyList.vue?vue&type=template&id=564815d3&scoped=true"
import script from "./levyList.vue?vue&type=script&lang=ts"
export * from "./levyList.vue?vue&type=script&lang=ts"
import style0 from "./levyList.vue?vue&type=style&index=0&id=564815d3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564815d3",
  null
  
)

export default component.exports